<template>
    <div
        class="relative w-full"
        ref="wrapper"
    >
        <label
            class="select-filter"
            :class="{
                'select-filter-active': active,
            }"
            @click="toggle"
        >
            <p class="label label-small">
                Who
            </p>

            <p class="select-filter-note">
                <template v-if="selected">
                    {{ countAsText }}
                </template>
                <template v-else>
                    Add guests
                </template>
            </p>
        </label>

        <DeleteButton
            v-if="selected"
            class="absolute top-1/2 right-3 xl:right-5 -translate-y-1/2"
            @click.prevent="clear"
        />

        <Transition>
            <Dropdown
                class="w-full"
                title="Select"
                placement="sm-left"
                v-model:active="active"
                @close="active = false"
            >
                <div
                    class="space-y-3 sm:space-y-5 [&>div:not(:last-child)]:pb-3 sm:[&>div:not(:last-child)]:pb-5 divide-y divide-brand-2-950/10"
                    :class="{ 'opacity-60 pointer-events-none': loading }"
                >
                    <NumberFilter
                        label="Guests"
                        name="guests"
                        v-model:value.number="count.guests"
                    />

                    <NumberFilter
                        label="Bedrooms"
                        name="bedrooms"
                        v-model:value.number="count.bedrooms"
                    />

                    <NumberFilter
                        label="Bathrooms"
                        name="bathrooms"
                        v-model:value.number="count.bathrooms"
                    />
                </div>
            </Dropdown>
        </Transition>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, useTemplateRef, watch } from 'vue';

    import DeleteButton from '@js/src/components/DeleteButton.vue';
    import Dropdown from '@js/src/components/Dropdown.vue';
    import NumberFilter from '@js/src/components/NumberFilter.vue';

    const emit = defineEmits([
        'change',
        'close',
    ]);

    const props = defineProps([
        'loading',
        'guestsCount',
        'bedroomsCount',
        'bathroomsCount',
    ]);

    const wrapper = useTemplateRef('wrapper');

    const active = ref(false);
    const count = ref({
        guests: props.guestsCount,
        bedrooms: props.bedroomsCount,
        bathrooms: props.bathroomsCount,
    });

    const selected = computed(() => {
        return Object.values(count.value)
            .filter(value => value)
            .length > 0;
    });

    const countAsText = computed(() => {
        return Object.entries(count.value)
            .filter(([key, value]) => value)
            .map(([key, value]) => {
                return `${value} ${key}`;
            }).join(', ');
    });

    watch(() => count, () => {
        emit('change', count.value);
    }, {
        deep: true,
    });

    watch(active, (value) => {
        if (!value) {
            emit('close');
        }
    });

    function toggle() {
        active.value = !active.value;
    }

    function clear() {
        count.value = {
            guests: 0,
            bedrooms: 0,
            bathrooms: 0,
        };

        emit('change', count.value);
        emit('close');
    }

    onMounted(() => {
        window.addEventListener('click', function (e) {
            if (wrapper.value && !wrapper.value.contains(e.target)) {
                active.value = false;
            }
        });
    });
</script>
